import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaRocket, FaRegCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Hero.css";
import { useLocalContext } from "../../context/LocalContext";
import { resolveSiteName } from "../../utils/siteConfig";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.75 } },
};

const fade = {
  hidden: { opacity: 0, scale: 0.98 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.75 } },
};

const Hero = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();
  const brand = resolveSiteName(webinfo);

  return (
    <section className="hro" aria-label="Hero">
      <div className="hro__blob one" aria-hidden="true" />
      <div className="hro__blob two" aria-hidden="true" />

      <div className="hro__wrap">
        <div className="hro__grid">
          <motion.div initial="hidden" animate="show" variants={fadeUp}>
            <div className="hro__badge">
              <FaRocket className="hro__badgeIcon" />
              {brand} · Digital Services
            </div>

            <h1 className="hro__title">
              Your digital presence, <span>built to perform</span>
            </h1>

            <p className="hro__sub">
              We design, develop, and market websites that attract customers, rank on
              Google, and convert visitors into leads — with transparent timelines
              and measurable results.
            </p>

            <ul className="hro__chips">
              <li>Custom websites</li>
              <li>SEO & marketing</li>
              <li>E-commerce setup</li>
              <li>Ongoing care</li>
            </ul>

            <div className="hro__actions">
              <button className="hro__btn hro__btn--primary" onClick={() => navigate("/contact")}>
                Start Your Project <FaArrowRight />
              </button>
              <button className="hro__btn hro__btn--ghost" onClick={() => navigate("/services")}>
                View All Services
              </button>
            </div>

            <div className="hro__stats">
              <div className="hro__stat">
                <b>50+</b>
                <span>Websites launched</span>
              </div>
              <div className="hro__stat">
                <b>95%</b>
                <span>Client satisfaction</span>
              </div>
              <div className="hro__stat">
                <b>10–21d</b>
                <span>Average delivery time</span>
              </div>
            </div>
          </motion.div>

          <motion.div className="hro__card" variants={fade} initial="hidden" animate="show">
            <div className="hro__cardTop">
              <div>
                <p className="hro__cardKicker">What's included</p>
                <h3 className="hro__cardTitle">Full-service digital package</h3>
              </div>
              <span className="hro__chip">From $499</span>
            </div>

            <div className="hro__preview">
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1170&auto=format&fit=crop"
                alt="Digital dashboard preview"
              />
            </div>

            <ul className="hro__list">
              <li>
                <span className="hro__tick"><FaRegCheckCircle /></span>
                Responsive website design & development
              </li>
              <li>
                <span className="hro__tick"><FaRegCheckCircle /></span>
                On-page SEO and Google Analytics setup
              </li>
              <li>
                <span className="hro__tick"><FaRegCheckCircle /></span>
                Contact forms, chat, and lead capture
              </li>
              <li>
                <span className="hro__tick"><FaRegCheckCircle /></span>
                30 days post-launch care included
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
